import React, { useEffect } from 'react';

import { MastheadLink, MastheadLinkList } from 'lib/sanity/types';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';
import { NavbarPopoverItem } from 'components/Masthead/Header/Popover/PopoverItem';
import { NavBarPopoverNavigation } from 'components/Masthead/Header/Popover/Shared';

interface Props {
  linkListEntry: MastheadLinkList;
  isLoggedIn: boolean;
}

export const NavBarSecondaryLinksPopoverOverlay = ({ isLoggedIn, linkListEntry }: Props) => {
  const ubi = useUbiMastheadHeader();

  const onSecondaryLinkClick = (link: MastheadLink) => {
    ubi.logSecondaryLinkInteraction({
      container: linkListEntry.trackingID,
      identifier: link.trackingID,
      uri: link.href,
    });
  };

  useEffect(() => {
    ubi.logSecondaryLinksContainerImpression(linkListEntry.trackingID);
  }, [linkListEntry.trackingID, ubi]);

  return (
    <NavBarPopoverNavigation>
      <NavbarPopoverItem isLoggedIn={isLoggedIn} linkListEntry={linkListEntry} onClick={onSecondaryLinkClick} />
    </NavBarPopoverNavigation>
  );
};
